import script from "./SignIntroduce.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignIntroduce.vue?vue&type=script&lang=ts&setup=true"

import "./SignIntroduce.vue?vue&type=style&index=0&id=071f8ab8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071f8ab8"]])

export default __exports__